exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#formErrors{margin:0;padding-top:0}#formErrors h3{margin:5px 0;font-size:15px;font-weight:700}#formErrors div.alert-danger{border:1px solid #e86a6b;background:#fff8f9;text-align:left;color:#333;border-radius:5px;padding:15px;width:100%}#formErrors ul{padding-left:35px}#formErrors ul li{font-size:14px}", ""]);

// exports
